import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Grid, Header, Table } from 'semantic-ui-react'
import ipaexplanations from './ipaexplanations';

/*
 * Component to show all IPA explanations in a table
 */

class IpaExplanationTable extends Component {

  render() {

    const ipafont = {
      fontFamily: 'Voces, sans-serif',
    };

    const { ipa } = this.props;
    const rows = ipa && ipa.split(' ').map((c,index) => 
        <Table.Row key={index}>
          <Table.Cell>
            <Header as='h3' textAlign='left' style={ipafont}>{c}</Header>
          </Table.Cell>
          <Table.Cell textAlign='left' fontSize='14px'>
            {ipaexplanations[c]}
          </Table.Cell>
        </Table.Row>
    );

    return (
      <Grid columns={1} padded>
      <Grid.Column>
        <Table textAlign='left' compact>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>IPA</Table.HeaderCell>
            <Table.HeaderCell textAlign='left' >Explanation</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {rows}
        </Table.Body>
      </Table>
      </Grid.Column>
      </Grid>
    );
  }
}

IpaExplanationTable.propTypes = {
  ipa: PropTypes.string.isRequired
};

export default IpaExplanationTable;







// WEBPACK FOOTER //
// ./src/IpaExplanationTable.js